import React from 'react';
import ConnectivityLogs from './conectivityLogs/ConnectivityLogs';
import CategoriesMenu from './CategoriesMenu';
import RoomServicesMenu from './room/RoomServicesMenu';
import RoomImagesMenu from './room/RoomImagesMenu';
import { useZitoneoUI } from '../../../contexts/ZitoneoUIContext';
import {
    VisibleContentScope,
    ZitoneoContentType,
} from '../../../types/zitoneoServicesTypes';
import ImageTypesMenu from './images/ImageTypesMenu';

const ZitoneoServicesSidebar = () => {
    const { visibleContentScope, visibleContentType } = useZitoneoUI();

    return (
        <nav className='services-sidebar__container'>
            {visibleContentScope === VisibleContentScope.ROOM &&
                (visibleContentType === ZitoneoContentType.IMAGES ? (
                    <RoomImagesMenu />
                ) : (
                    <RoomServicesMenu />
                ))}
            {visibleContentType === ZitoneoContentType.IMAGES &&
                visibleContentScope !== VisibleContentScope.ROOM && (
                    <ImageTypesMenu />
                )}
            {visibleContentType === ZitoneoContentType.SERVICES && (
                <CategoriesMenu />
            )}
            <ConnectivityLogs />
        </nav>
    );
};

export default ZitoneoServicesSidebar;
